import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { IChart, IBlock, IUsers, IBolt } from '@/icons/parts';

const NAV: { to: string; label: string; Icon: typeof IChart; end?: boolean }[] = [
  { to: '/admin', label: 'Dashboard', Icon: IChart, end: true },
  { to: '/admin/inventory', label: 'Inventory Manager', Icon: IBlock },
  { to: '/admin/subscribers', label: 'Subscribers', Icon: IUsers },
  { to: '/admin/agents', label: 'AI Agents', Icon: IBolt },
];

interface AdminLayoutProps {
  children: ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div className="admin-shell">
      <aside className="sidebar">
        <div className="sidebar-section">
          <div className="sidebar-label">Admin Console</div>
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <div className="icon"><Icon size={16} /></div>
              <div style={{ flex: 1 }}>{label}</div>
            </NavLink>
          ))}
        </div>
      </aside>
      <div className="main">{children}</div>
    </div>
  );
}
